/**
 * Texto de ubicación que deben ver otros usuarios en el perfil, según flags públicos.
 * Si no existen columnas nuevas (pre-migración), se usa `location` como antes.
 * @param {Record<string, unknown> | null | undefined} profile
 * @returns {string | null}
 */
export function buildProfilePublicLocationLine(profile) {
  if (!profile) return null;
  const migrated = typeof profile.public_show_pais === 'boolean';
  if (!migrated) {
    const legacy = typeof profile.location === 'string' ? profile.location.trim() : '';
    return legacy || null;
  }
  const showPais = profile.public_show_pais !== false;
  const showCiudad = profile.public_show_ciudad !== false;
  const showLoc = profile.public_show_localidad === true;
  const pais = typeof profile.pais === 'string' ? profile.pais.trim() : '';
  const ciudad = typeof profile.ciudad === 'string' ? profile.ciudad.trim() : '';
  const localidad = typeof profile.localidad === 'string' ? profile.localidad.trim() : '';
  const parts = [];
  if (showPais && pais) parts.push(pais);
  if (showCiudad && ciudad) parts.push(ciudad);
  if (showLoc && localidad) parts.push(localidad);
  if (parts.length) return parts.join(' · ');
  return null;
}

/**
 * Resumen interno (todos los niveles rellenados) para mantener `profiles.location` alineado.
 * @param {{ pais?: string, ciudad?: string, localidad?: string }} row
 */
export function buildProfileLocationSummary(row) {
  const parts = [row.pais, row.ciudad, row.localidad]
    .map(v => (typeof v === 'string' ? v.trim() : ''))
    .filter(Boolean);
  return parts.length ? parts.join(' · ') : null;
}
